<template>
    <div class="footer">
        <div class="container">
            <div class="footer-top">
                <h3>友情链接</h3>
                <div class="col-md-12 top-footer">
                    <ul>
                        <li v-for="item in activeItemList" :key="item.url">
                            <a :href="item.url" target="_blank" :title="item.desc">{{item.title}}</a>
                            <span>{{item.desc}}</span>
                        </li>
                    </ul>
                </div>
                <div class="clearfix"></div>
            </div>
            <p class="copyright"> {{settingList.copyright}}</p>
            <p class="mianze"> {{settingList.mianze}}</p>
        </div>
    </div>
</template>

<script>
export default {
  name: 'Footer',
  components: {},
  data() {
    return {
      itemList: [],
      settingList: []
    }
  },
  computed: {
    activeItemList() {
      return this.itemList.filter(item => item.status === 1)
    }
  },
  created() {
    this.getData()
    this.getSiteCopyright()
  },
  methods: {
    getData() {
      var timeStamp = new Date().getTime()
      this.$http.get('static/data/friend_link.json' + '?' + timeStamp).then(res => {
        this.itemList = res.data
      },
      res => {
        console.log('error')
      }
      )
    },
    getSiteCopyright() {
      if (localStorage.getItem('settingList')) {
        this.settingList = JSON.parse(localStorage.getItem('settingList'))[0]
      } else {
      var timeStamp = new Date().getTime()
      this.$http.get('static/data/setting.json' + '?' + timeStamp).then(res => {
        localStorage.setItem('settingList', JSON.stringify(res.data))
        this.settingList = res.data[0]
      },
      res => {
        console.log('error')
      }
      )
      }
    }
  }

}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
